import React,{forwardRef} from 'react'
import FeatureForm from './FeatureForm'
const AddFeature = forwardRef((props, ref) => {
    const {featureSave, updateFeatureList, formValidateError,isButtonLoader} = props;
    return (
        <>
            <FeatureForm
                featureSave={featureSave}
                updateFeatureList={updateFeatureList}
                formValidateError={formValidateError}
                formActionType={'insert'}
                isInfoOpenHandler={props.isInfoOpenHandler}
                ref={ref}
                isButtonLoader={isButtonLoader}
            />
        </>
    )
})
export default AddFeature